export const isEllipsisActive = (ref) => {
  const element = ref?.current;
  if (!element) return false;
  return element.offsetWidth < element.scrollWidth;
};
